
import * as settings from '../settings'
import React from 'react';
import { useNavigate } from "react-router-dom";

export const replaceAll = (str, find, replace) => {
  str = str.replace(find, replace).replace(find, replace).replace(find, replace).replace(find, replace).replace(find, replace).replace(find, replace).replace(find, replace).replace(find, replace).replace(find, replace).replace(find, replace)
  return str
}

export const isNumeric = (str) => {
  if (typeof str != "string") return false // we only process strings!  
  return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}

export const deleteAreaCode = (phone) => {
  if (phone.substring(0, 4) === '+972') return phone.replace('+972', '0')
  return phone
}
export const getNumberWithIsraelAreaCode = (phone) => {
  if (phone.substring(0, 1) === '0') return phone.replace('0', '+972')
  return phone

}

export const deleteUnnecessaryPhoneChars = (phone) => {
  return replaceAll(replaceAll(replaceAll(replaceAll(phone, '-', ''), ' ', ''), '(', ''), ')', '')
}

export const convertDateTimeToApplicationTime = (date) => {
  const formatedYear = date.getFullYear()
  const formatedMonth = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : '' + (date.getMonth() + 1)
  const formatedDay = date.getDate() < 10 ? '0' + date.getDate() : '' + date.getDate()
  const formatedHours = date.getHours() < 10 ? '0' + date.getHours() : '' + date.getHours()
  const formatedMinutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : '' + date.getMinutes()
  const formatted_date = formatedDay + '/' + formatedMonth + '/' + formatedYear + ' ' + formatedHours + ':' + formatedMinutes
  return formatted_date
}

export const debounce = (fn, wait = 150) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), wait);
  };
};

export const formatDateFromDB = (dateString, short, rtl = false, showTime = true) => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return ''
  const pad = (num) => num.toString().padStart(2, '0');

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = date.getFullYear();
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  if (!rtl) {
    if (!short) {
      return `${day}/${month}/${year} ${showTime ? `${hours}:${minutes}:${seconds}` : ''}`;
    }
    else {
      return `${day}/${month}/${year.toString().slice(-2)} ${showTime ? `${hours}:${minutes}` : ''}`;
    }
  }
  else {
    if (!short) {
      return `${showTime ? `${hours}:${minutes}:${seconds}` : ''} ${day}/${month}/${year}`;
    }
    else {
      return `${showTime ? `${hours}:${minutes}` : ''} ${day}/${month}/${year.toString().slice(-2)}`;
    }
  }
}



export const removeSpecialChars = (msg) => {
  if (msg.includes('<?') || msg.includes('?>')) {
    return msg.replace(/<\?/g, '?').replace(/\?>/g, '?');
  }
  return msg;
}

export const formatDuration = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  // Pad each number with a leading zero if it is less than 10
  const paddedHours = hours.toString().padStart(2, '0');
  const paddedMinutes = minutes.toString().padStart(2, '0');
  const paddedSeconds = remainingSeconds.toString().padStart(2, '0');

  return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
}

export const isTodayDateTime = (dateTime) => {
  const dateTimeObj = new Date(dateTime)

  // Set the time of startOfToday to midnight
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);

  // Set the time of endOfToday to the last millisecond of today
  const endOfToday = new Date(startOfToday);
  endOfToday.setHours(23, 59, 59, 999);

  return dateTimeObj >= startOfToday && dateTimeObj <= endOfToday;
}

export const formatDateToSQLServer = (date) => {
  const padZero = (num, size) => {
    let s = num.toString();
    while (s.length < size) s = "0" + s;
    return s;
  };

  const year = date.getFullYear();
  const month = padZero(date.getMonth() + 1, 2); // Months are zero-based
  const day = padZero(date.getDate(), 2);
  const hours = padZero(date.getHours(), 2);
  const minutes = padZero(date.getMinutes(), 2);
  const seconds = padZero(date.getSeconds(), 2);
  const milliseconds = padZero(date.getMilliseconds(), 3);

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
}

export const getFileTypeByContentType = (contentType) => {
  switch (contentType) {
    case 'image/jpeg':
      return 'jpeg'
    case 'application/pdf':
      return 'pdf'
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return 'docx'
    case 'application/msword':
      return 'doc'
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      return 'pptx'
    case 'application/vnd.ms-powerpoint':
      return 'ppt'
    case 'audio/mpeg':
      return 'mp3'
    case 'audio/ogg':
      return 'ogg'
    case 'audio/wav':
      return 'wav'
    case 'audio/x-m4a':
      return 'm4a'
    case 'audio/aac':
      return 'aac'
    case 'video/mp4':
      return 'mp4'
    case 'text/plain':
      return 'txt'
    case 'text/csv':
      return 'csv'
    case 'application/vnd.ms-excel':
      return 'xls'
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return 'xlsx'
    case 'audio/webm':
    case 'video/webm':
      return 'webm'
    default:
      return contentType.split('/')[1]
  }
}

export const isPbxSupportActionType = (pbxType, actionType) => settings.PBX_SUPPORT_ACTIONS?.[actionType]?.includes(pbxType)


export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  }
  return ComponentWithRouterProp;
}

export function getContactNameByConv(conv) {
  let contactName
  if (conv?.crmId && typeof conv.crmId === 'object' && conv.crmId.name) {//?.crmId?.name
    contactName = conv.crmId.name
  }
  else if (conv?.contactId && typeof conv.contactId === 'object') {
    contactName = conv.contactId.fullName
  }
  else if (conv?.displayName) {
    contactName = conv.displayName
  }
  return contactName
}

export function normalizePhone(v) {
  if (!v) return
  const digits = v.replace(/\D/g, '');
  return digits.startsWith('972')
    ? '0' + digits.slice(3)
    : v;
};

export function stripPhoneFormatting(value) {
  if (!value) return '';
  return value.replace(/\D/g, '');
}

// export function translateServerApiErrors(toTranslateStr, translateFunc) {
//   if (!toTranslateStr || !translateFunc) return toTranslateStr
//   let [_, details] = toTranslateStr.split('Contact validation failed:');
//   if (!details) details = toTranslateStr
//   const fieldErrors = details.split(',').map((err, i) => `${i + 1}) ${translateFunc(err.trim())}`).join('\n');
//   return fieldErrors
// }

// export function translateServerApiErrors(raw, t) {
//   if (!raw || typeof t !== 'function') return raw;

//   // Remove Mongoose prefix once
//   const [, details = raw] = raw.split('Contact validation failed:');
//   const chunks = details.split(',');            // multiple errors → ["…", "…"]

//   return chunks
//     .map((chunk, i) => normalise(chunk.trim(), i + 1, t))
//     .join('\n');
// }

// /* ---------- helpers ---------- */

// function normalise(err, idx, t) {
//   /* A)  {{טלפון}} must be numeric
//    * B)  טלפון must be numeric
//    * C)  Field {{טלפון}} is required
//    */

//   /* 1. collect variables inside {{…}} */
//   const braceRe = /{{\s*([^{}]+?)\s*}}/g;
//   const vars = [...err.matchAll(braceRe)].map(m => m[1].trim());

//   let key, map = {};

//   if (vars.length) {
//     /* replace each {{…}} → X1, X2 … */
//     key = err.replace(braceRe, (_, v, n, str) => {
//       const i = vars.indexOf(v.trim());
//       const token = `X${i + 1}`;
//       map[token] = v.trim();
//       return token;
//     });
//   } else {
//     /* B or bare C */
//     const fieldRequired = /^Field\s+(.+?)\s+is\s+required$/i.exec(err);
//     if (fieldRequired) {
//       map = { X1: fieldRequired[1].trim() };
//       key = 'Field X1 is required';
//     } else {
//       /* label first pattern */
//       const m = /^(.+?)\s+(must|is|are)\s+(.+)$/i.exec(err);
//       if (!m) return `${idx}) ${err}`;       // fail‑safe fallback

//       map = { X1: m[1].trim() };
//       key = `X1 ${m[2]} ${m[3].trim()}`;     // e.g. "X1 must be numeric"
//     }
//   }

//   /* look up translation */
//   const tx = t(key, map);
//   const text = tx !== key         // found?
//       ? tx
//       : Object.keys(map).reduce((s, k) => s.replace(k, map[k]), key);

//   return `${idx}) ${text}`;
// }


export function translateServerApiErrors(raw, t) {
  if (!raw || typeof t !== 'function') return raw;

  // strip the optional Mongoose prefix
  const [, details = raw] = raw.split('Contact validation failed:');

  return details
    .split(',')                        // multiple errors separated by commas
    .map((chunk, i) => normalise(chunk.trim(), i + 1, t))
    .join('\n');
}

/* ---------- helper ---------- */
function normalise(err, idx, t) {
  /* 1. literal lookup first (covers any fully‑specified keys) */
  const direct = t(err);
  if (direct !== err) return `${idx}) ${direct}`;

  /* 2. wrapped‑label {{…}} pattern */
  const braceRe = /{{\s*([^{}]+?)\s*}}/g;
  const vars    = [...err.matchAll(braceRe)].map(m => m[1].trim());

  let key, map = {};

  if (vars.length) {
    key = err.replace(braceRe, (_, v) => {
      const tok = `X${vars.indexOf(v.trim()) + 1}`;
      map[tok]  = v.trim();
      return tok;
    });
  } else {
    /* 3. colon pattern  field: message */
    const colon = /^([^:]+):\s*(.+)$/.exec(err);
    if (colon) {
      const field = colon[1].trim();          // mainPhone
      let rest    = colon[2].trim();          // mainPhone must be …
      if (rest.startsWith(field)) rest = rest.slice(field.length).trim();
      map = { X1: field };
      key = `X1 ${rest}`;                     // "X1 Phone number too long"
    } else {
      /* 4. Field … is required */
      const req = /^Field\s+(.+?)\s+is\s+required$/i.exec(err);
      if (req) {
        map = { X1: req[1].trim() };
        key = 'Field X1 is required';
      } else {
        /* 5. bare label‑first pattern */
        const m = /^(.+?)\s+(must|is|are)\s+(.+)$/i.exec(err);
        if (!m) return `${idx}) ${err}`;      // unknown → return as‑is
        map = { X1: m[1].trim() };
        key = `X1 ${m[2]} ${m[3].trim()}`;
      }
    }
  }

  /* translate and fallback */
  const tx   = t(key, map);
  const text = tx !== key
    ? tx
    : Object.entries(map).reduce((s, [tok, v]) => s.replace(tok, v), key);

  return `${idx}) ${text}`;
}
